import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { INCLUDES } from '../constants/content';
import { PriceDisplay } from './PriceDisplay';
export function IncludesStack() {
  return <section className="w-full bg-cream py-14 sm:py-20" data-id="element-121" data-mp="854eimf829s3">
      <div className="mx-auto max-w-3xl px-4" data-id="element-122" data-mp="d2mrcnwd195d">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-10 text-center font-display text-3xl font-700 leading-tight text-ink sm:text-4xl" data-id="element-123" data-mp="d3eb91glhift">
          Esto Es Todo Lo Que Recibís Con{' '}
          <span className="text-crimson" data-id="element-124" data-mp="3bk0e0s0a4x98">Pollería Rentable 2026</span>:
        </motion.h2>

        <ul className="space-y-3" data-id="element-125" data-mp="3gk4n3wyuyppf">
          {INCLUDES.map((item, i) => <motion.li key={i} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 rounded-xl bg-white p-4 shadow-sm ring-1 ring-black/5" data-id="element-126" data-mp="3gh8rwgeeaf4o" data-mpi={i}>
              <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-green-600" aria-hidden="true" data-id="element-127" data-mp="2ae51l3znnz19" />
              <span className="text-base leading-relaxed text-gray-800" data-id="element-128" data-mp="2o6umf53g6xws">
                <strong className="font-700 text-ink" data-id="element-129" data-mp="2k4g7ux6takbb">{item.title}</strong> —{' '}
                {item.desc}
                {item.value != null && <span className="ml-1 font-700 text-gold-dark" data-id="element-130" data-mp="2t436xcc2je17">
                    (<PriceDisplay amount={item.value} data-id="element-131" data-mp="2t1qgeas8vvcj" /> de Valor)
                  </span>}
              </span>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}